import Vue from "vue"
const eventBus = new Vue({
  data() {
    return {
      eventQueue: {

      }
    }
  },
  methods: {
    onlyOn(eventName, uniqueKey, callback) {
      if (this.eventQueue[eventName]) {
        this.eventQueue[eventName][uniqueKey] = [callback]
      } else {
        this.eventQueue[eventName] = {
          [uniqueKey]: [callback]
        }
      }
    },
    onlyEmit(eventName, uniqueKey, data) {
      const callbacks = this.eventQueue?.[eventName]?.[uniqueKey] || []
      callbacks.map(callback => {
        try {
          callback.call(this, data)
        } catch (error) {
          console.error(error)
        }
      })
    },
    onlyOff(eventName, uniqueKey) {
      if (this.eventQueue[eventName]) {
        this.eventQueue[eventName][uniqueKey] = []
      }
    }
  },
  beforeDestroy() {
    this.eventQueue = null
  }
})


export default eventBus